import styled from "styled-components";
import { Label } from "components/bootstrap";
const ActiveInvestigationLabel = styled(Label).attrs({
  bsStyle: "primary",
  bsSize: "xsmall"
})`
  display: inline-flex;
  margin-left: 5px;
  vertical-align: text-bottom;
`;
export default ActiveInvestigationLabel;
